import React from 'react';
import './TopicCard.css'

const TopicCard = ({ topicName, views, estimatedTime, description, tags, topicStatus = 0 }) => {

    const colors = ["#666666", "#e67300", "#63ad55", "#566cae"];

    return (
        <div className="topic-card card">
            <div className="card-header">
                <div>
                    <span className="topic-card-name card-title">{topicName}</span>
                    <div
                        className="status-indicator"
                        style={{ backgroundColor: colors[topicStatus] }}
                        title={`Status: ${topicStatus}`} // Optional tooltip for status
                    />
                </div>
            </div>
            <div className="topic-card-body">
                <div>
                    {tags.map((tag, index) => (
                        <span key={index} className="tag">{tag}</span>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default TopicCard;
